import { Notification, NotificationStatus } from '@cp-shared-10/frontend-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { EditStatus } from 'common';

export const NotificationForEditStatus: React.FC<{ editStatus: EditStatus }> = ({ editStatus }) => {
    const { t } = useTranslation('my-profile-marketing-consent-settings');
    const translationPrefix = 'edit-view.notification';

    switch (editStatus) {
        case EditStatus.SUCCESS: {
            return (
                <Notification
                    status={NotificationStatus.success}
                    headline={t(`${translationPrefix}.success.headline`)}
                    text={t(`${translationPrefix}.success.text`)}
                    testId={'editStatus'}
                    className="u-mt-small"
                />
            );
        }
        case EditStatus.ERROR: {
            return (
                <Notification
                    status={NotificationStatus.error}
                    text={t(`${translationPrefix}.error.text`)}
                    testId={'editStatus'}
                    className="u-mt-small"
                />
            );
        }
        default: {
            return null;
        }
    }
};
